@if (show | async) {
    <section
        itemscope
        itemprop="mainEntity"
        itemtype="https://schema.org/Question"
        [ngClass]="additionalClasses"
        class="flex max-w-4xl justify-between rounded-2xl bg-white">
        <div class="px-5 py-7 md:pl-10" [ngClass]="{ 'pb-6': open }">
            <h5
                (click)="toggleOpen()"
                class="flex cursor-pointer items-center justify-between pb-0 font-semibold"
                itemprop="name">
                {{ faq.question }}
            </h5>
            <div
                class="pt-4 text-sm text-grey-500 md:w-3/4 md:text-base"
                [ngClass]="open ? 'block' : 'hidden'"
                itemscope
                itemprop="acceptedAnswer"
                itemtype="https://schema.org/Answer">
                <app-rich-text-document
                    [delayRendering]="true"
                    [document]="faq.answer?.json"
                    [resolvedLinks]="resolvedLinks"
                    itemprop="text"></app-rich-text-document>
            </div>
        </div>
        <div
            (click)="toggleOpen()"
            class="flex cursor-pointer items-center rounded-r-2xl p-4"
            [ngClass]="{ 'bg-red-400': open, 'bg-grey-500': !open }">
            <svg
                class="inline h-2 flex-shrink-0 transform fill-current text-white transition duration-500"
                [ngClass]="{ '-scale-y-100': open }"
                viewBox="0 0 20 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.666666 2.33333C0.666056 2.02179 0.774557 1.71988 0.973331 1.48C1.08526 1.34498 1.22273 1.23338 1.37786 1.15158C1.53299 1.06978 1.70273 1.01938 1.87737 1.00328C2.052 0.987179 2.2281 1.00569 2.39557 1.05775C2.56304 1.10981 2.7186 1.19439 2.85333 1.30666L10 7.28L17.16 1.52C17.2964 1.40924 17.4533 1.32653 17.6218 1.27662C17.7902 1.22672 17.9669 1.21059 18.1416 1.22918C18.3163 1.24776 18.4856 1.30069 18.6398 1.38492C18.794 1.46915 18.93 1.58303 19.04 1.72C19.1614 1.85795 19.2529 2.01951 19.3089 2.19452C19.3649 2.36954 19.3841 2.55424 19.3653 2.73703C19.3466 2.91982 19.2902 3.09676 19.1998 3.25673C19.1094 3.41671 18.9869 3.55627 18.84 3.66666L10.84 10.1067C10.6014 10.3028 10.3022 10.41 9.99333 10.41C9.6845 10.41 9.38524 10.3028 9.14666 10.1067L1.14667 3.44C0.985309 3.30624 0.857757 3.13633 0.774359 2.94405C0.69096 2.75177 0.654064 2.54254 0.666666 2.33333Z" />
            </svg>
        </div>
        <noscript class="pb-4 md:w-3/4">
            <app-rich-text-document
                [delayRendering]="true"
                [document]="faq.answer?.json"
                [resolvedLinks]="resolvedLinks"></app-rich-text-document>
        </noscript>
    </section>
}
